export default "__VITE_ASSET__4e6534d0__"